export const BENEFITS = [
  "aboutbadi.professionals.benefits.1",
  "aboutbadi.professionals.benefits.2",
  "aboutbadi.professionals.benefits.3",
  "aboutbadi.professionals.benefits.4",
];
